export default "__VITE_ASSET__DK2iExUU__"